<template>
    <div id="settingMain">
      <!--模型-->
<!--        <div class="bimDream" id="dreamCanvas" v-if="systemType=='1'"></div>-->
      <div class="contentMain">
        <el-table
          :header-cell-style="{background:'#335ABB',color:'#FFF'}"
          stripe
          ref="multipleTable"
          :data="measures"
          tooltip-effect="dark"
          style="width: 100%"
          :row-key="getRowKey"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
          <el-table-column prop="alias" label="别名"></el-table-column>
          <el-table-column prop="measureNo" label="测点编号"></el-table-column>
          <el-table-column prop="sortId" label="序号" :formatter="setValue"></el-table-column>
        </el-table>
        <el-row style="text-align: center;margin-top: 10px">
          <el-button type="primary" @click="save()">保 存</el-button>
        </el-row>
      </div>

    </div>
</template>

<script>
    import * as d3 from 'd3'
    // 声明Viewer及其它
    let viewer3D = null;
    let app = null;
export default {
    name: "InterfaceSetting",
    components: {},
    data() {
        return {
            // Bim
            viewToken:'',
            currentpoint:'', //是否自定义展示
            measures: [],
            multipleSelection: [],
            sorted: [],
            measures_selected:[],
            finnalArr:[],
            systemType: '0',//系统类型,

        };
    },
    mounted: function () {
        this.viewToken=localStorage.getItem("path")
        this.currentpoint=localStorage.getItem("currentpoint")
        this.systemType = localStorage.getItem("systemType");
        this.getSortMeasure();
        // if( localStorage.getItem("systemType")=='1'){
        //     this.bimInit();
        // }
    },
    methods: {
        /*bim模型部分*/
        bimInit() {
            // 配置bim加载项
            let loaderConfig = new BimfaceSDKLoaderConfig();
            loaderConfig.viewToken = this.viewToken;
            BimfaceSDKLoader.load(loaderConfig, this.successCallback, this.failureCallback);
        },
        // 加载成功回调函数
        successCallback(viewMetaData) {
            if (viewMetaData.viewType === "3DView") {
                // 获取DOM元素
                let dom4Show = document.getElementById('dreamCanvas');
                // 设置WebApplication3D的配置项
                let webAppConfig = new Glodon.Bimface.Application.WebApplication3DConfig();
                webAppConfig.domElement = dom4Show;
                // webAppConfig.enableViewHouse = false;  // 不开启ViewHouse
                webAppConfig.Toolbars = [];   // 取消工具条
                // 创建WebApplication3D,用以显示模型
                app = new Glodon.Bimface.Application.WebApplication3D(webAppConfig);
                app.addView(this.viewToken);
                // 从WebApplication获取viewer3D对象
                viewer3D = app.getViewer();
                // 增加加载完成监听事件
                viewer3D.addEventListener(Glodon.Bimface.Viewer.Viewer3DEvent.ViewAdded, () => {
                    // 自适应屏幕大小
                    window.onresize = function () {
                        viewer3D.resize(document.documentElement.clientWidth, document.documentElement.clientHeight - 40)
                    };
                    // 手动渲染场景(这里不渲染也行，可以注销)
                    viewer3D.render();
                    // 设置自定义视角(即图形展示位置),如果实时监控更新位置，用最新的坐标，否则用初始坐标
                    if(this.currentpoint){
                        setTimeout(()=>{viewer3D.setCameraStatus(localStorage.getItem('currentpoint'))},100)
                    }
                });
            }
        },

        /*表格选择部分*/
        getSortMeasure(){
            this.$axios.get("/api/monitor/system/indexSet/getSortMeasure").then((res) => {
                this.measures = res.data.datas.values.measureList;
                // 多选框回显,用于在页面加载，筛选出sortId不为0的对象，打勾
                this.measures = res.data.datas.values.measureList;
                var lists = this.measures.map((value, index, arr) => {
                    if (value.sortId !== 0) {
                        return this.measures[index];
                    }
                });
                if (lists) {
                    lists.forEach(list => {
                        if(list && list!== undefined){
                            // toggleRowSelection(row,selected)方法用于对传入的值进行勾选,row为被勾选的行的数据,selected设置是否选中
                            this.$refs.multipleTable.toggleRowSelection(list, true);
                        }
                    });
                }
            });
        },
        setValue(row, col, value) {
            if (value == 0) {
                return "无";
            } else {
                return value;
            }
        },
        // 保存选中的数据id,row-key就是要指定一个key标识这一行的数据
        getRowKey(row){
            // return row.id;
        },
        // 列表勾选选择,val为所有已经被勾选的行数据
        handleSelectionChange(val) {
            this.sorted = val;
            let flag = 1;
            this.sorted.forEach((measure) => {
                measure.sortId = flag++;
            });
            // 后台接收的数组对象只需要一两个参数的信息,故提取数组对象中个别属性组成新数组对象
            this.measures_selected = this.sorted.map(item => {
                return Object.assign({},{'id':item.id,'sortId':item.sortId})
            })
            // js 删除两个数组中id相同的对象
            let allMeasure_arr =  this.measures;
            let measures_selectedArr = this.measures_selected;
            let measure_notSelectedArr = allMeasure_arr.filter(item => {
                // 将measures_selectedArr数组所有id集合的数组赋值给临时数组
                // map()返回一个新数组,并且不会影响原数组
                let tableIDList = measures_selectedArr.map(v => v.id)
                // 返回所有临时数组中没有item.id的item
                return !tableIDList.includes(item.id)
            })
            let measure_notSelectedArr_new = measure_notSelectedArr.map(item => {
                return Object.assign({},{'id':item.id,'sortId':0})
            })
            // 合并数组
            this.finnalArr = this.measures_selected.concat(measure_notSelectedArr_new);
        },
        // 清空选择的值
        clearSelect(){
            this.$refs.multipleTable.clearSelection();
        },
        save(){
            this.$axios.post('/api/monitor/system/saveIndexMeasure',this.finnalArr).then(res => {
                if(res.data.status == 200){
                    this.$message({
                        type:"success",
                        message: res.data.datas.values,
                    });
                    this.clearSelect(); // 防止序号累积
                    this.getSortMeasure(); // 重新请求数据
                }else{
                    return false
                }
            })
        },
    },
};
</script>

<style>
    #table .el-scrollbar__wrap {
        overflow-x: hidden;
    }
    #settingMain .el-table{
      color: #A7CCF6;
    }

    #settingMain .el-table__row {
      background-color: #0B3A68 !important;
    }

    #settingMain .el-table--striped .el-table__body tr.el-table__row--striped td{
      background-color: #021535;
    }

    #settingMain .el-table td{
      border: unset;
    }

    #settingMain .el-table th.is-leaf{
      border-bottom: none;
    }

    #settingMain .el-pagination__total{
      color: #FFF;
    }
</style>

<style scoped>
  .bimDream{
    margin-bottom: 10px;
  }
  #dreamCanvas{
    width: 100%;
    height: 300px;
    flex: 1;
  }
  .contentMain{
    border: 1px solid rgb(19,100,182);
    height: calc(100% - 2px);
    margin: 0 15px;
    background-image: linear-gradient(to bottom right,rgba(6,21,43,1), rgba(13,39,82,0.8));
    text-align: center;
    overflow-y: auto;
  }


</style>




// WEBPACK FOOTER //
// src/components/systemSetting/interface-setting.vue